import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FormPreview from "./FormPreview";
 
import api from "../../api/axiosInstance";
const FormView = () => {debugger;
  const { id } = useParams(); // Extract form ID from URL
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

const recordGuidStr = id;
const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
const loggedinUserid = userData ? userData.email : null; // Get logged-in user email
  const [refreshKey, setRefreshKey] = useState(0);
    const refreshParent = () => {
    setRefreshKey(prev=>prev+1); // forces re-render
  };

  

  useEffect(() => {
            debugger;
   // Use api to fetch the data
   api
   .get(`/Form/PreviewForm`, {
          params: {
            recordGuidStr,
            loggedinUserid
          }
  
  }) // Replace with your actual API URL
   .then((response) => {debugger;
     setFormData(response.data);
     setLoading(false);
   })
   .catch((err) => {
     setError(err.message || "Something went wrong");
     setLoading(false);
   });
  }, [recordGuidStr,loggedinUserid,refreshKey]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
<div 
style={{
  width: "90%",
    margin: "auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
}}
>
      {/* <h1 className="text-2xl font-bold mb-4">Form Preview</h1> */}
      <FormPreview
       formData={formData} 
       onRefresh={refreshParent}/>
    </div>
  );
};

export default FormView;
